import React, { Component } from 'react';
import onClickOutside from 'react-onclickoutside';
import { Picker,  BackgroundImageFn } from 'emoji-mart';

export class ChatEmojiPicker extends Component<any, any> {

    handleClickOutside = () => {
        if (typeof this.props.handleClickOutside === 'function') {
            this.props.handleClickOutside();
        }
    };

    onSelect = (emoji: any) => {
        if (typeof this.props.onSelect === 'function') {
            this.props.onSelect(emoji);
        }
    };
  

    getEmojiSourceFunc = (): BackgroundImageFn => {
        const emojiSrc = '../../assets/content/images/emoji-datasource@4.0.4/img/apple/sheets-256/32.png';
        return (set: any, sheetSize: any) => emojiSrc;
    };

    public render() {
        return <Picker style={this.props.customStyle} onSelect={this.onSelect} />;
    }
}

export default onClickOutside(ChatEmojiPicker);
